/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccessCondition } from '../models/AccessCondition';
import { PermissionGrantInput } from '../models/PermissionGrantInput';

export class UpdateRoleRequest {
  /**
  * The name of the role
  */
  'name': string;
  /**
  * The permissions of the role
  */
  'permissionGrants': Array<PermissionGrantInput>;
  /**
  * The condition of the role, keyed by name
  */
  'accessConditions'?: Array<AccessCondition>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "permissionGrants",
      "baseName": "permissionGrants",
      "type": "Array<PermissionGrantInput>",
      "format": ""
    },
    {
      "name": "accessConditions",
      "baseName": "accessConditions",
      "type": "Array<AccessCondition>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateRoleRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

